export default __webpack_public_path__ + "static/media/instagram.7d6c1159.svg";